import { createModel } from "hox";
import React, { useState } from "react"
import { TablePaginationConfig } from "antd/es/table/interface";
import { ICatalogParams, ICatalogDetail } from "./dataCatalogTypes"
import { catalogService, fieldService, FieldDetails } from "./dataCatalogService"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { useMdmModel } from "../../../model/mdmModel"
export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}
const turnStr = (boole: boolean | undefined): number => {
    return boole ? 1 : 0
}
export const useDataCatalogModel = createModel(function () {
    const { initCatalogData } = useMdmModel()
    const initSearchParams: ICatalogParams = {}
    const initDataSource: ICatalogDetail[] = []
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const cataLogParamAdd: ICatalogDetail = {}
    const initFieldDataSource: FieldDetails[] = []
    //查询条件
    const [searchParam, setSearchParam] = useState<ICatalogParams>({})
    //列表数据
    const [dataSource, setDataSource] = useState<ICatalogDetail[]>(initDataSource);
    //分页参数
    const [cataLogPage, setCataLogPage] = useState<TablePaginationConfig>(initPage);
    //新增参数
    const [addParam, setAddParam] = useState<ICatalogDetail>(cataLogParamAdd)
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行
    const [selectedRow, setSelectedRow] = useState<ICatalogDetail>({})
    //弹框状态
    const [drawerVisible, setDrawerVisible] = useState<boolean>(false)
    //弹框值
    const [drawerTitle, setDrawerTitle] = useState<string>("")
    //数据字段列表
    const [fieldData, setFieldData] = useState<FieldDetails[]>(initFieldDataSource)
    //数据字段选中key
    const [fieldSelectRowKeys, setFieldSelectRowKeys] = useState<React.Key[]>([])
    //数据字段选中行
    const [fieldSelectRow, setFieldSelectRow] = useState<FieldDetails>({})
    //数据字段新增
    const [fieldAdd, setFieldAdd] = useState<FieldDetails>({})

    const updataAddParam = (updateParam: ICatalogDetail) => {
        setAddParam({ ...addParam, ...updateParam })
    }
    const updataEditParam = (uptataParam: ICatalogDetail) => {
        setSelectedRow({ ...selectedRow, ...uptataParam })
    }
    const updataData = async (params: ICatalogDetail) => {
        const { allowRemoteInsert, allowRemoteUpdate, allowMultiBranch, allowRemoteSelect, allowRemoteDelete, status, ...param } = params
        const data = {
            ...selectedRow,
            allowRemoteInsert: turnStr(allowRemoteInsert as boolean | undefined),
            allowRemoteUpdate: turnStr(allowRemoteUpdate as boolean | undefined),
            allowMultiBranch: turnStr(allowMultiBranch as boolean | undefined),
            allowRemoteSelect: turnStr(allowRemoteSelect as boolean | undefined),
            allowRemoteDelete: turnStr(allowRemoteDelete as boolean | undefined),
            status: turnStr(status as boolean | undefined),
            ...param
        }
        const { retData, retMsg } = await catalogService.update(data)
        globalPrompt("message", { type: "success", text: retMsg })
        retData && initCatalogData();
        return retData
    }
    const insertData = async (params: ICatalogDetail) => {

        const { allowRemoteInsert, allowRemoteUpdate, allowMultiBranch, allowRemoteSelect, allowRemoteDelete, status, ...param } = params
        const data = {
            allowRemoteInsert: turnStr(allowRemoteInsert as boolean | undefined),
            allowRemoteUpdate: turnStr(allowRemoteUpdate as boolean | undefined),
            allowMultiBranch: turnStr(allowMultiBranch as boolean | undefined),
            allowRemoteSelect: turnStr(allowRemoteSelect as boolean | undefined),
            allowRemoteDelete: turnStr(allowRemoteDelete as boolean | undefined),
            status: turnStr(status as boolean | undefined),
            ...param
        }
        const { retData, retMsg } = await catalogService.insert(data)
        globalPrompt("message", { type: "success", text: retMsg })
        retData && initCatalogData();
        return retData
    }
    const updateSearchParam = (updateParam: ICatalogParams) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParams);
        const resetPage = { pageSize: 15, pageNum: 1 }
        loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: ICatalogParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? cataLogPage.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? cataLogPage.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await catalogService.page(params)
        const { records, ...pg } = retData;
        setCataLogPage(transPgToPagination(pg));
        setDataSource(records);
    }
    const loadField = async () => {
        let params = {
            "catalog": selectedRow.code,
            page: {
                pageSize: 200,
                pageNum: 1
            }
        }
        const { retData } = await fieldService.onePage(params)
        const { records } = retData
        setFieldData(records)
    }
    const changeField = (value: FieldDetails) => {
        setFieldSelectRow({ ...fieldSelectRow, ...value })

    }
    const addChangeField = (value: FieldDetails) => {
        setFieldAdd({ ...fieldAdd, ...value })
    }
    const insertField = async () => {
        let data = {
            ...fieldAdd,
            catalog: selectedRow.code
        }
        const { retData, retMsg } = await fieldService.insert(data)
        if (retData) {
            loadField();
            setDrawerVisible(!drawerVisible);
            setFieldAdd({})
            globalPrompt("message", { type: "success", text: retMsg });
        }
    }
    const editField = async () => {
        const { retData, retMsg } = await fieldService.update(fieldSelectRow)
        if (retData) {
            loadField();
            setDrawerVisible(!drawerVisible)
            globalPrompt("message", { type: "success", text: retMsg });
        }
    }
    const removeField = async () => {
        const { code, catalog } = fieldSelectRow
        const { retData, retMsg } = await fieldService.remove(catalog as string, code as string)
        if (retData) {
            loadField();
            globalPrompt("message", { type: "success", text: retMsg });
        }
    }
    return {
        searchParam,
        dataSource,
        selectedRowKeys,
        cataLogPage,
        addParam,
        selectedRow,
        drawerVisible,
        drawerTitle,
        fieldData,
        fieldSelectRow,
        fieldSelectRowKeys,
        fieldAdd,
        setAddParam,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setCataLogPage,
        loadData,
        resetSearchParam,
        updateSearchParam,
        updataAddParam,
        insertData,
        updataEditParam,
        setSelectedRow,
        updataData,
        setDrawerVisible,
        setDrawerTitle,
        loadField,
        setFieldData,
        setFieldSelectRow,
        setFieldSelectRowKeys,
        changeField,
        addChangeField,
        insertField,
        editField,
        removeField
    }
});